export default "__VITE_ASSET__DK9Wl4RS__"